import script from "./LotteryButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotteryButton.vue?vue&type=script&setup=true&lang=ts"

import "./LotteryButton.vue?vue&type=style&index=0&id=673bc44a&scoped=true&lang=css"

import exportComponent from "/tmp/build_806be7d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673bc44a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QAvatar,QBtn,QTooltip});
